export default __webpack_public_path__ + "static/RobotoSlab-Bold-5bc3a854931d797f1e7e1bc1546ae1ef.woff2";